/**
 * Type guard to check if a RichTextEditorFile is a File
 */
export function isFile(file) {
    return file instanceof File;
}
/**
 * Type guard to check if a RichTextEditorFile is a ConversationAttachment with URL
 */
export function isConversationAttachmentWithUrl(file) {
    return (file &&
        typeof file === 'object' &&
        'id' in file &&
        'url' in file &&
        !(file instanceof File));
}
